// extracted by mini-css-extract-plugin
export default {"section":"Section_section__fHDcp","container":"Section_container__uzXZz"};